import { Module } from '@nestjs/common';
import {
  IMAGE_STORAGE_ADAPTER,
  LocalDiskImageStorageAdapter,
  PrismaService,
} from '@cart/api-data-access';
import { AuditService } from '../audit/audit.service';
import { AuthModule } from '../auth/auth.module';
import { MediaModule } from '../media/media.module';
import { NotificationsModule } from '../notifications/notifications.module';
import {
  CommerceAdminController,
  PublicStorefrontConfigController,
} from './commerce-admin.controller';
import { CommerceAdminService } from './commerce-admin.service';
import { ImageQuotaService } from './image-quota.service';
import { ImageSettingsService } from './image-settings.service';
import { ImageTrashPurgeService } from './image-trash-purge.service';

@Module({
  imports: [AuthModule, NotificationsModule, MediaModule],
  controllers: [CommerceAdminController, PublicStorefrontConfigController],
  providers: [
    CommerceAdminService,
    PrismaService,
    AuditService,
    ImageQuotaService,
    ImageSettingsService,
    ImageTrashPurgeService,
    { provide: IMAGE_STORAGE_ADAPTER, useClass: LocalDiskImageStorageAdapter },
  ],
})
export class CommerceAdminModule {}
